import { get, post } from '@web3/base-utils';
import {
  GetAccountOneParams,
  GetAccountOneRes,
  PostDisclaimerRecordParam,
  GetAccountSumParam,
  GetAccountSumRes,
  GetAccountAllParam,
  GetAccountAllRes,
} from '@/types/account';
import { baseApiUrl } from '@/config/api';

export const getAccountOneV2 = (params: GetAccountOneParams) => {
  return get<GetAccountOneRes>(`${baseApiUrl}/v2/account/one`, params);
};

export const getAccountOneV3 = (params: GetAccountOneParams) => {
  return get<GetAccountOneRes>(`${baseApiUrl}/v3/account/one`, params, {
    useThirdConfig: true,
  });
};

export const postDisclaimerRecord = (params: PostDisclaimerRecordParam) => {
  return post(`${baseApiUrl}/v3/account/disclaimer/record`, params);
};

export const getAccountSumV3 = (params: GetAccountSumParam) => {
  return post<GetAccountSumRes>(`${baseApiUrl}/v3/account/sum`, params);
};

export const getAccountAllV3 = (params: GetAccountAllParam) => {
  return post<GetAccountAllRes>(`${baseApiUrl}/v3/account/all`, params);
};
